// extracted by mini-css-extract-plugin
export default {"fullWidth":"jo-z","image":"ko-z","lazyLoadPicture":"lo-z","lazyLoadSpinner":"mo-z","lazyLoadSpin":"no-z","lazyLoadImage":"oo-z","hasStyledAspectRatio":"po-z"};